var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Logo"},[_vm._v("\n  CovidNames\n")])}
var staticRenderFns = []

export { render, staticRenderFns }